// API Configuration
const API_CONFIG = {
  // Backend API base URL
  BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  
  // Environment
  ENV: process.env.NODE_ENV || 'development',
  
  // Timeout for API requests (in milliseconds)
  TIMEOUT: 30000,
  
  // Headers
  DEFAULT_HEADERS: {
    'Content-Type': 'application/json',
  }
};

// API endpoints
export const API_ENDPOINTS = {
  // Chat endpoints
  CHAT_SESSION: `${API_CONFIG.BASE_URL}/chat/session`,
  CHAT_MESSAGE: `${API_CONFIG.BASE_URL}/chat`,
  CHAT_HISTORY: (sessionId) => `${API_CONFIG.BASE_URL}/chat/history/${sessionId}`,
  
  // RAG endpoints
  RAG_FAST: `${API_CONFIG.BASE_URL}/rag/fast`,
  RAG_QUERY: `${API_CONFIG.BASE_URL}/rag/query`,
  
  // Gita data endpoints
  GITA_CHAPTERS: `${API_CONFIG.BASE_URL}/gita/chapters`,
  GITA_CHAPTER: (chapterNumber) => `${API_CONFIG.BASE_URL}/gita/chapter/${chapterNumber}`,
  GITA_VERSE: (chapterNumber, verseNumber) => `${API_CONFIG.BASE_URL}/gita/verse/${chapterNumber}/${verseNumber}`,
  GITA_SEARCH: `${API_CONFIG.BASE_URL}/gita/search`,
  GITA_RANDOM: `${API_CONFIG.BASE_URL}/gita/random`,
  GITA_STATS: `${API_CONFIG.BASE_URL}/gita/stats`,
  
  // Embedding endpoints
  EMBEDDINGS_GENERATE: `${API_CONFIG.BASE_URL}/embeddings/generate`,
  EMBEDDINGS_SEARCH: `${API_CONFIG.BASE_URL}/embeddings/search`,
};

export default API_CONFIG; 